import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { arrayOf, bool, func, number, object, shape, string } from 'prop-types';
import { actions as surveyActions } from '../Common/SurveyUtilizationState';
import SurveyUtilizationDisplay from './SurveyUtilizationDisplay';

const SURVEY_LIBRARY_URL = '/iframe/merit/merit-admin/survey_lib';
const SURVEY_LIBRARY_CHANGE_URL = '/market-analysis/survey-library/marketpay-library';

class SurveyUtilization extends Component {
  static propTypes = {
    dispatch: func,
    history: object,
    location: object,
    match: object,
    getSurveyActions: func,
    surveys: shape({
      bottomRetries: number,
      bottomSurveys: arrayOf(
        shape({
          id: string,
          jobCount: number,
          name: string,
          utilization: number
        })
      ),
      bottomSurveysError: string,
      bottomSurveysLoading: bool,
      topRetries: number,
      topSurveys: arrayOf(
        shape({
          id: string,
          jobCount: number,
          name: string,
          utilization: number
        })
      ),
      topSurveysError: string,
      topSurveysLoading: bool
    }),
    userRights: object
  };

  constructor(props) {
    super(props);
    this.browseSurveysClick = this.browseSurveysClick.bind(this);
    this.filterBottomSurveys = this.filterBottomSurveys.bind(this);
    this.fetchBottomSurveys = this.fetchBottomSurveys.bind(this);
    this.fetchTopSurveys = this.fetchTopSurveys.bind(this);
    this.surveyClick = this.surveyClick.bind(this);
    this.changeSurveysClick = this.changeSurveysClick.bind(this);
  }

  componentDidMount() {
    this.fetchTopSurveys();
    this.fetchBottomSurveys();
  }

  browseSurveysClick() {
    const { history } = this.props;
    history.push({ pathname: SURVEY_LIBRARY_URL });
  }

  changeSurveysClick() {
    const { history } = this.props;
    history.push({ pathname: SURVEY_LIBRARY_CHANGE_URL });
  }

  filterBottomSurveys() {
    const { bottomSurveys, bottomSurveysLoading, topSurveys, topSurveysLoading } = this.props.surveys;
    // In the event that a survey list contains fewer than 10 surveys
    // they tend to bleed over to the bottom utilized. Filter them out
    if (!topSurveysLoading && !bottomSurveysLoading && bottomSurveys && topSurveys) {
      return bottomSurveys.filter(bottomSurvey => {
        const surveyInTopSurveys = topSurveys.find(top => {
          return top.id === bottomSurvey.id;
        });
        if (!surveyInTopSurveys) return true;
        else return false;
      });
    }
    return bottomSurveys;
  }

  fetchBottomSurveys() {
    const { dispatch } = this.props;
    surveyActions.getBottomSurveys(dispatch);
  }

  fetchTopSurveys() {
    const { dispatch } = this.props;
    surveyActions.getTopSurveys(dispatch);
  }

  surveyClick(surveyId) {
    const { history } = this.props;
    const surveyUrl = `/iframe/merit/merit-admin/survey_lib?initial_survey_id=${surveyId}`;
    history.push({ pathname: surveyUrl });
  }

  canChangeSurveyLibrary() {
    const { userRights } = this.props;
    return userRights.superAdmin || userRights.siteAdmin;
  }

  render() {
    const {
      topSurveys,
      topSurveysError,
      bottomSurveysError,
      topSurveysLoading,
      bottomSurveysLoading,
      topRetries,
      bottomRetries
    } = this.props.surveys;
    const filteredBottomSurveys = this.filterBottomSurveys();

    return (
      <SurveyUtilizationDisplay
        bottomSurveys={filteredBottomSurveys}
        bottomSurveysError={bottomSurveysError}
        bottomSurveysLoading={bottomSurveysLoading}
        bottomRetries={bottomRetries}
        browseSurveysClick={this.browseSurveysClick}
        changeSurveysClick={this.changeSurveysClick}
        topSurveys={topSurveys}
        topSurveysError={topSurveysError}
        topSurveysLoading={topSurveysLoading}
        topRetries={topRetries}
        reFetchBottomSurveys={this.fetchBottomSurveys}
        reFetchTopSurveys={this.fetchTopSurveys}
        surveyClick={this.surveyClick}
        canChangeSurveyLibrary={this.canChangeSurveyLibrary()}
      />
    );
  }
}

const mapStateToProps = ({ landingDashboard, session }) => ({
  surveys: landingDashboard.SurveyUtilization,
  userRights: session.user.rights
});

export default connect(mapStateToProps)(withRouter(SurveyUtilization));
